module.exports = __webpack_public_path__ + "static/media/hearthstone.9ad0756f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/hearthstone.png
// module id = 95
// module chunks = 0